// src/components/Payment/Transcationquery.js
import React from 'react';

const Transcationquery = () => {
  return (
    <div>
      <h2>Transcationquery</h2>
      <p>This is the Transcationquery component.</p>
    </div>
  );
};

export default Transcationquery;
